export const FS_META_PIXEL_ID = "2088352118670061";
export const FS_GA4_ID = "G-FY7WXGYPQW";
export const FS_POSTHOG_KEY =
  "phc_nFJsAdPZ6fD84pDXZxGZYQxZzZatvUejbqmMkaRkhYdL";

const CHECKOUT_TRACKED_KEY = "fs_checkout_tracked";
const PURCHASE_TRACKED_KEY = "fs_purchase_tracked";

export const getTrackingSearchParams = (search = window.location.search) =>
  new URLSearchParams(search);

export const getTrackingProduct = (qs = getTrackingSearchParams()) =>
  qs.get("product") || qs.get("med_pref") || "glp1";

export const getDefaultTrackingValue = (product) =>
  product.includes("tirz") ? 149 : 99;

const loadScript = (src, id) =>
  new Promise((resolve) => {
    if (id && document.getElementById(id)) {
      resolve();
      return;
    }
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    if (id) script.id = id;
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.head.appendChild(script);
  });

export const loadMetaPixel = () => {
  if (window.fbq) return Promise.resolve();

  return new Promise((resolve) => {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
    /* eslint-enable */

    const done = () => resolve();
    const interval = setInterval(() => {
      if (window.fbq) {
        clearInterval(interval);
        done();
      }
    }, 50);
    setTimeout(() => {
      clearInterval(interval);
      done();
    }, 5000);
  });
};

export const loadGA4 = () => {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  return loadScript(
    `https://www.googletagmanager.com/gtag/js?id=${FS_GA4_ID}`,
    "fs-ga4-script"
  );
};

export const loadPostHog = () => {
  if (window.posthog?.__loaded) return Promise.resolve();

  return new Promise((resolve) => {
    /* eslint-disable */
    !(function (t, e) {
      var o, n, p, r;
      e.__SV ||
        ((window.posthog = e),
        (e._i = []),
        (e.init = function (i, s, a) {
          function g(t, arg) {
            var o = arg.split(".");
            2 == o.length && ((t = t[o[0]]), (arg = o[1]));
            t[arg] = function () {
              t.push([arg].concat(Array.prototype.slice.call(arguments, 0)));
            };
          }
          ((p = t.createElement("script")).type = "text/javascript"),
            (p.async = !0),
            (p.src = s.api_host + "/static/array.js"),
            (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(
              p,
              r
            );
          var u = e;
          for (
            void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
              u.people = u.people || [],
              u.toString = function (t) {
                var label = "posthog";
                return (
                  "posthog" !== a && (label += "." + a),
                  t || (label += " (stub)"),
                  label
                );
              },
              u.people.toString = function () {
                return u.toString(1) + ".people (stub)";
              },
              o =
                "capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys onSessionId".split(
                  " "
                ),
              n = 0;
            n < o.length;
            n++
          )
            g(u, o[n]);
          e._i.push([i, s, a]);
        }),
        (e.__SV = 1));
    })(document, window.posthog || []);
    /* eslint-enable */

    const done = () => resolve();
    const interval = setInterval(() => {
      if (window.posthog?.capture) {
        clearInterval(interval);
        done();
      }
    }, 50);
    setTimeout(() => {
      clearInterval(interval);
      done();
    }, 5000);
  });
};

export const loadFsTrackingSdks = () =>
  Promise.all([loadMetaPixel(), loadGA4(), loadPostHog()]);

/**
 * Checkout page: Meta InitiateCheckout, GA4 begin_checkout, PostHog checkout_started.
 */
export const fireCheckoutPageTracking = () => {
  if (sessionStorage.getItem(CHECKOUT_TRACKED_KEY)) return;

  const qs = getTrackingSearchParams();
  const product = getTrackingProduct(qs);
  const value = getDefaultTrackingValue(product);

  if (window.fbq) {
    window.fbq("init", FS_META_PIXEL_ID);
    window.fbq("track", "PageView");
    window.fbq("track", "InitiateCheckout", {
      content_name: product,
      content_category: "GLP-1",
      value,
      currency: "USD",
    });
  }

  if (window.gtag) {
    window.gtag("js", new Date());
    window.gtag("config", FS_GA4_ID);
    window.gtag("event", "begin_checkout", {
      currency: "USD",
      value,
      items: [
        {
          item_name: product,
          item_category: "GLP-1",
          price: value,
          quantity: 1,
        },
      ],
    });
  }

  if (window.posthog?.init) {
    window.posthog.init(FS_POSTHOG_KEY, {
      api_host: "https://us.i.posthog.com",
    });
    window.posthog.__loaded = true;
  }

  if (window.posthog?.capture) {
    window.posthog.capture("checkout_started", {
      product,
      value,
      source: qs.get("source"),
      landing_url: qs.get("landing_url"),
      utm_source: qs.get("utm_source"),
      utm_campaign: qs.get("utm_campaign"),
      fbclid: qs.get("fbclid"),
    });
  }

  sessionStorage.setItem(CHECKOUT_TRACKED_KEY, "1");
};

/**
 * Thank-you page: Meta Purchase, GA4 purchase, PostHog purchase_completed.
 * Call only after payment is successfully captured.
 */
export const firePurchasePageTracking = ({
  search = window.location.search,
  orderId: orderIdOverride,
  value: valueOverride,
} = {}) => {
  const storageKey = orderIdOverride
    ? `${PURCHASE_TRACKED_KEY}_${orderIdOverride}`
    : PURCHASE_TRACKED_KEY;

  if (sessionStorage.getItem(storageKey)) return;

  const qs = getTrackingSearchParams(search);
  const product = qs.get("product") || "glp1";
  const orderId =
    orderIdOverride ||
    qs.get("order_id") ||
    qs.get("transaction_id") ||
    crypto.randomUUID();
  const value =
    valueOverride !== undefined && valueOverride !== null && valueOverride !== ""
      ? Number(valueOverride)
      : Number(qs.get("value")) || getDefaultTrackingValue(product);

  if (window.fbq) {
    window.fbq("track", "Purchase", {
      content_name: product,
      content_category: "GLP-1",
      value,
      currency: "USD",
    });
  }

  if (window.gtag) {
    window.gtag("event", "purchase", {
      transaction_id: orderId,
      currency: "USD",
      value,
      items: [
        {
          item_name: product,
          item_category: "GLP-1",
          price: value,
          quantity: 1,
        },
      ],
    });
  }

  if (window.posthog?.capture) {
    window.posthog.capture("purchase_completed", {
      order_id: orderId,
      product,
      value,
      currency: "USD",
      source: qs.get("source"),
      landing_url: qs.get("landing_url"),
    });
  }

  sessionStorage.setItem(storageKey, "1");
};

/**
 * Preserves all incoming URL params and adds order / attribution fields for thank-you.
 */
export const buildThankYouNavigatePath = ({
  orderId,
  productTotal,
  email,
  phoneNumber,
  hashFragment = "",
}) => {
  const params = getTrackingSearchParams(window.location.search);

  const product = getTrackingProduct(params);
  if (!params.get("product")) {
    params.set("product", product);
  }

  if (orderId) {
    params.set("order_id", String(orderId));
    params.set("transaction_id", String(orderId));
  }

  if (
    productTotal !== undefined &&
    productTotal !== null &&
    productTotal !== ""
  ) {
    params.set("value", String(productTotal));
  }

  if (email) params.set("email", email);
  if (phoneNumber) params.set("phone", phoneNumber);

  const qs = params.toString();
  return `/thankyou-page${qs ? `?${qs}` : ""}${hashFragment || ""}`;
};

export const initCheckoutPageTracking = async () => {
  await loadFsTrackingSdks();
  fireCheckoutPageTracking();
};

export const initThankYouPageTracking = async ({
  orderId,
  productTotal,
  search,
}) => {
  await loadFsTrackingSdks();

  if (window.posthog?.init && !window.posthog.__loaded) {
    window.posthog.init(FS_POSTHOG_KEY, {
      api_host: "https://us.i.posthog.com",
    });
    window.posthog.__loaded = true;
  }

  if (window.fbq && !window._fsPixelInited) {
    window.fbq("init", FS_META_PIXEL_ID);
    window._fsPixelInited = true;
  }

  if (window.gtag && !window._fsGa4Configured) {
    window.gtag("js", new Date());
    window.gtag("config", FS_GA4_ID);
    window._fsGa4Configured = true;
  }

  firePurchasePageTracking({
    search: search || window.location.search,
    orderId,
    value: productTotal,
  });
};
